export enum Role {
  // Suplias staff roles
  Admin = 'administrator.administrator',
  Staff = 'manager.staff',
  Accountant = 'manager.accountant',
  Buyer = 'manager.buyer',
  WarehouseOfficer = 'manager.warehouse_officer',

  // Seller staff roles
  SellerManager = 'sales_officer.manager',
  SellerRetailManager = 'sales_officer.rem',
  SellerRep = 'sales_officer.rep',
  SellerBA = 'sales_officer.ba',
  SellerCS = 'sales_officer.cs',

  // Others
  Agent = 'agent.agent',
}

export const supliasStaff = [
  Role.Admin,
  Role.Staff,
  Role.WarehouseOfficer,
  Role.Accountant,
]

export const sellerStaff = [
  Role.SellerManager,
  Role.SellerRep,
  Role.SellerBA,
  Role.SellerCS,
]

export const everyone = [...supliasStaff, ...sellerStaff]
